import { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';

const AuthRoute = () => {
  const { isLoggedIn, isAPIAuthenticated } = useContext(AuthContext);

  // If already verified(authenticated), show already verified page instead.
  if (isLoggedIn === true) {
    if (isAPIAuthenticated === false) {
      return (
        <Container
          fluid
          className="p-0 h-100 w-100"
          style={{ maxHeight: '100%', overflow: 'auto' }}
        >
          <Outlet />
        </Container>
      );
    } else return <Navigate to="/verify-already-success" />;
  } else return <Navigate to="/login" />;
};

export default AuthRoute;
